<script>
	import { Progress } from '@rutynka/helper-progress'
	export let name;

	let progress;

	function handleClick() {
		console.log('click', progress.store_progress({"exerciseTime":69,"dT":new Date()}))
	}
</script>

<main>
	<h1>Hello {name}!</h1>
	<p>Visit the <a href="https://svelte.dev/tutorial">Svelte tutorial</a> to learn how to build Svelte apps.</p>
	<button on:click={handleClick}>Heat up</button>
</main>
<Progress bind:this={progress}/>

<style>
	button {background-color:hsla(100, 80%, 60%,0.9)}
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>